import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { BaseParamsService } from '@app/core/base-params.service';

export interface UnsubscribePayload {
  token: string;
  subunitId: string | null;
}

export const prepareUnsubscribePayload = ({ token, subunitId }: UnsubscribePayload): Record<string, string> => {
  let data: Record<string, string> = {
    token: token,
  };
  if (subunitId !== undefined && subunitId !== null) {
    data = {
      ...data,
      subunit_id: subunitId,
    };
  }
  return data;
};

export abstract class UnsubscriptionBaseService {
  constructor(protected baseParamsService: BaseParamsService) {}

  public abstract unsubscribe(identifier: string, payload: UnsubscribePayload): Observable<unknown>;

  protected memberUrl(): string {
    return `${environment.webforms_api}/v3/${this.baseParamsService.slug}/members`;
  }
}
